var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeCloseBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8089 7.39498C16.5139 5.97798 17.6989 3.95298 17.9919 1.62398C18.0609 1.07698 17.6729 0.57698 17.1239 0.50798C16.5839 0.43398 16.0759 0.82698 16.0079 1.37498C15.5689 4.86698 12.5559 7.49998 8.99995 7.49998C5.44395 7.49998 2.43095 4.86698 1.99195 1.37498C1.92395 0.82698 1.41395 0.43798 0.874946 0.50798C0.326946 0.57698 -0.0610538 1.07698 0.00794618 1.62398C0.300946 3.95298 1.48595 5.97798 3.19095 7.39498L0.878946 9.70698C0.489946 10.096 0.489946 10.732 0.878946 11.121C1.26695 11.51 1.90395 11.51 2.29295 11.121L4.89595 8.51798C5.84995 8.99998 6.89695 9.31798 7.99995 9.43898V13C7.99995 13.55 8.44995 14 8.99995 14C9.54995 14 9.99995 13.55 9.99995 13V9.43898C11.1019 9.31798 12.1499 8.99998 13.1029 8.51798L15.7069 11.121C16.0959 11.51 16.7319 11.51 17.1209 11.121C17.5099 10.732 17.5099 10.096 17.1209 9.70698L14.8089 7.39498Z",
    fill: "#151A30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseBlack);
export default __webpack_public_path__ + "static/media/eye-close-black.e759b241fc8b49a31d11d2f4d1f958e8.svg";
export { ForwardRef as ReactComponent };